import { c as _c } from "react/compiler-runtime";
import { useGetFulfilAt, useGetHasSelectedPreorderDetails, useGetOrderType, useHasHydrated } from '@ordering/stores/OrderStore/hooks';
import { PreorderType } from '@ordering/gql/graphql';
import { useStorefrontConfig } from '@ordering/providers/StorefrontConfig/StorefrontConfig';
import { useAcceptingOrders } from '@ordering/providers/AcceptingOrders/AcceptingOrdersProvider';
export const usePreorderEnabled = orderTypeIdOverride => {
  const $ = _c(3);
  const {
    orderPreferences
  } = useStorefrontConfig();
  const orderType = useGetOrderType();
  const orderTypeId = orderTypeIdOverride ?? orderType?.id;
  if (!orderPreferences.preorderConfiguration?.enabled) {
    return false;
  }
  if (orderPreferences.preorderConfiguration?.preorderType !== PreorderType.Objective) {
    return false;
  }
  const orderTypeIds = orderPreferences.preorderConfiguration?.orderTypeIds;
  if (orderTypeIds && orderTypeIds.length > 0 && orderTypeId) {
    let t0;
    if ($[0] !== orderTypeId || $[1] !== orderTypeIds) {
      t0 = orderTypeIds.includes(orderTypeId);
      $[0] = orderTypeId;
      $[1] = orderTypeIds;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  return false;
};
export const useShouldSelectPreorderTime = t0 => {
  const {
    shouldIgnorePreviousSelection: t1
  } = t0 === undefined ? {} : t0;
  const shouldIgnorePreviousSelection = t1 === undefined ? false : t1;
  const fulfilAt = useGetFulfilAt();
  const hasSelectedPreorderDetails = useGetHasSelectedPreorderDetails();
  const isPreorderEnabled = usePreorderEnabled();
  const hasHydrated = useHasHydrated();
  if (!hasHydrated) {
    return false;
  }
  if (!isPreorderEnabled) {
    return false;
  }
  if (!shouldIgnorePreviousSelection && hasSelectedPreorderDetails) {
    return false;
  }
  return fulfilAt == null;
};
export const useAllowPreorderWhenClosed = () => {
  const {
    orderPreferences
  } = useStorefrontConfig();
  const isPreorderEnabled = usePreorderEnabled();
  const allowPreorderWhenClosed = orderPreferences.preorderConfiguration?.allowPreorderWhenClosed;
  return !!(isPreorderEnabled && allowPreorderWhenClosed);
};